import { getMethodWithToken } from 'utils/services/apiService';
import url from 'utils/services/urls.json';

// Action Types
export const GET_CATEGORY_LIST = 'GET_CATEGORY_LIST';
export const GET_CATEGORY_LIST_SUCCESS = 'GET_CATEGORY_LIST_SUCCESS';
export const GET_CATEGORY_LIST_FAILURE = 'GET_CATEGORY_LIST_FAILURE';

// Action Creators
export const getCategoryList = () => ({
  type: GET_CATEGORY_LIST,
});

export const getCategoryListSuccess = (users) => ({
  type: GET_CATEGORY_LIST_SUCCESS,
  payload: users,
});

export const getCategoryListFailure = (error) => ({
  type: GET_CATEGORY_LIST_FAILURE,
  payload: error,
});

// Thunk Function
export const getCategoryListData = (external) => {
  return async (dispatch) => {
    dispatch(getCategoryList());
    try {
      const response = await getMethodWithToken(url?.categoryList);
      if (response?.status === 200 || response?.status === 201) {
        dispatch(getCategoryListSuccess(response?.data));
        if (external?.run === true) {
          external?.handleFunction(response?.data);
        }
      } else if (response?.status === 401 || response?.status === 403) {
        if (external?.authorize === true) {
          external?.handleAuthorizeFunction(response?.data);
        }
      } else {
        external?.handleErrorFunction(response?.data);
      }
    } catch (error) {
      dispatch(getCategoryListFailure(error?.message));
    }
  };
};
